// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__GrAfP","title":"Info_title__3ShlV","links":"Info_links__2oCTR","link":"Info_link__3VSp7","logo":"Info_logo__1LrgP"};